"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnAItem = exports.hideName = exports.hideID = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const account_1 = require("../../../base/account");
const constant_1 = require("../constant");
const hideID = (name) => {
    const hiddenPart = name.slice(3); // 문자열의 세 번째 인덱스부터 끝까지 추출
    const maskedPart = '*'.repeat(hiddenPart.length); // 추출한 부분의 길이만큼 '*' 문자를 반복
    const maskedString = name.slice(0, 3) + maskedPart; // 첫 세 글자와 가려진 부분을 결합하여 최종 결과 생성
    return maskedString;
};
exports.hideID = hideID;
const hideName = (name) => {
    //이름이 2글자인 경우 첫 글자만 노출하고 나머지 글자를 '*'로 가림
    if (name.length <= 2) {
        return name[0] + '*';
    }
    //문자열의 맨 앞과 맨 뒤 글자를 제외한 나머지 글자를 '*'로 가림
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
};
exports.hideName = hideName;
exports.QnAItem = react_1.default.memo(({ isHome, isAnswer, isContent, isTeacher, isMobile, isTablet, isSelected, isHistory, headItem, item, number, displayNumber, handlerShowDetail, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isViewerAdmin = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManager)(state));
    const isRequestion = item.number > 1;
    const renderStatus = headItem => {
        if (isContent && isTeacher && item[headItem.title] === constant_1.QNA_STATUS.CREATED) {
            item[headItem.title] = constant_1.QNA_STATUS.CLOSED;
        }
        return (react_1.default.createElement("p", { className: `overText2 ${item[headItem.title] === constant_1.QNA_STATUS.CLOSED
                ? 'pink'
                : item[headItem.title] === constant_1.QNA_STATUS.CREATED
                    ? 'purple'
                    : ''}` }, t(`supportRoom.${item.status}`)));
    };
    if (isMobile &&
        ['private', 'files', 'member', isHome ? '' : 'creation_time'].includes(headItem.title))
        return null;
    switch (headItem.title) {
        case 'answerStateAndName':
            return (react_1.default.createElement("div", { className: "qna-status-display", style: { gap: isMobile ? 8 : 12 } },
                react_1.default.createElement("div", { className: `qna_status_round ${item.status}` },
                    react_1.default.createElement("p", null, t(`supportRoom.${item.status}`))),
                react_1.default.createElement("p", { className: "overText" },
                    "[",
                    t(`supportRoom.${item.category}`),
                    "] ",
                    item.title)));
        case 'categoryAndName':
            return (react_1.default.createElement("div", { className: "overText" },
                "[",
                t(`supportRoom.${item.category}`),
                "] ",
                item.title));
        case 'files':
            return item.files.length > 0 ? (react_1.default.createElement("div", { className: "file" },
                react_1.default.createElement(common_1.Icon, { icon: "file", size: isTablet ? 14 : 20, fill: isSelected ? Colors_1.Colors.pur : Colors_1.Colors.w_grey }),
                react_1.default.createElement("p", { className: "overText2" },
                    "(",
                    item.files.length,
                    ")"))) : (react_1.default.createElement("p", null, "-"));
        case 'private':
            return item[headItem.title] ? (react_1.default.createElement(common_1.Icon, { icon: "locked", className: "locked", size: isTablet ? 14 : 20, fill: isSelected ? 'var(--pur-d, #8268d9)' : '#666666' })) : null;
        case 'content':
            return (react_1.default.createElement("div", { className: "locked-wrap" },
                isMobile
                    ? null
                    : //  isHistory ? (
                        // 	<>
                        // 		{item.number > number && (
                        // 			<Button
                        // 				className="btn_tur mobile-xxs"
                        // 				text={'supportRoom.nextQuestio'}
                        // 			/>
                        // 		)}
                        // 		{item.number <= number && (
                        // 			<Button
                        // 				className="btn_tur mobile-xxs"
                        // 				text={'supportRoom.initialQuestion'}
                        // 			/>
                        // 		)}
                        // 	</>
                        // ) :
                        isRequestion && (react_1.default.createElement(common_1.Button, { className: "btn_tur mobile-xxs", text: 'supportRoom.req' })),
                item['private'] && (react_1.default.createElement(common_1.Icon, { icon: "locked", className: "locked", size: 14, fill: isSelected ? 'var(--pur-d, #8268d9)' : '#666666' })),
                react_1.default.createElement("p", { className: `${isHome ? 'overText' : ''} title ${isMobile ? 'bold' : ''}` }, item.title)));
        case 'creation_time':
            return (react_1.default.createElement("p", { className: "overText2" }, (0, moment_1.default)(item[headItem.title]).format(isHome ? 'YYYY-MM-DD' : 'YYYY-MM-DD, HH:mm')));
        case 'status':
            return isMobile ? (react_1.default.createElement("div", { className: "qna-list-wrap" },
                item.files.length > 0 && (react_1.default.createElement("div", { className: "file" },
                    react_1.default.createElement(common_1.Icon, { icon: "file", size: 12, fill: isSelected ? Colors_1.Colors.pur : Colors_1.Colors.w_grey }),
                    react_1.default.createElement("p", { className: "overText2" },
                        "(",
                        item.files.length,
                        ")"))),
                react_1.default.createElement("p", { className: `overText2 ${isSelected ? '' : 'grey'}` }, (0, moment_1.default)(item['creation_time']).format('YYYY-MM-DD, HH:mm')),
                renderStatus(headItem))) : (renderStatus(headItem));
        case 'category':
            return isMobile ? (react_1.default.createElement("div", { className: "locked-wrap" },
                isRequestion && (react_1.default.createElement(common_1.Button, { className: "btn_tur mobile-xxs", text: 'supportRoom.req' })),
                react_1.default.createElement("p", { className: "overText2" }, t(`supportRoom.${item[headItem.title]}`)))) : (react_1.default.createElement("p", { className: "overText2" }, t(`supportRoom.${item[headItem.title]}`)));
        case 'etc':
            return (!isMobile && (react_1.default.createElement("p", { className: "under-line overText2", onClick: () => handlerShowDetail(item.root_id, Math.max(item.number - 1, 0)) }, "\uC790\uC138\uD788 \uBCF4\uAE30")));
        case 'author_name':
            if (isAnswer)
                return null;
            if (!isViewerAdmin && item.author_level === '04') {
                return (react_1.default.createElement("p", { className: "overText2" }, isMobile
                    ? t('supportRoom.question_name', { name: '관리자' })
                    : '관리자'));
            }
            return isTeacher ? (isMobile ? (react_1.default.createElement("div", { className: "qna-member-wrap" },
                react_1.default.createElement("p", { className: "overText2" }, t('supportRoom.question_name', {
                    name: `${item[headItem.title]} (${item['author_idf']})`,
                })))) : (react_1.default.createElement("p", { className: "overText2" },
                item[headItem.title],
                " (",
                item['author_idf'],
                ")"))) : (react_1.default.createElement("p", { className: "overText2" },
                (0, exports.hideName)(item[headItem.title]),
                " (",
                (0, exports.hideID)(item['author_idf']),
                ")"));
        case 'respondent_name':
            return (react_1.default.createElement("p", { className: "overText2" }, isMobile
                ? t('supportRoom.answer_name', {
                    name: isAnswer ? item.author_name : item.respondent_name,
                })
                : isAnswer
                    ? item.author_name
                    : item.respondent_name));
        case 'index':
            return (react_1.default.createElement("p", { className: "overText2 no-p", style: { ...(item.importance && { color: Colors_1.Colors.pur, fontWeight: 700 }) } }, item['importance'] ? '필독' : displayNumber));
        default:
            return react_1.default.createElement("p", { className: "overText2" }, item[headItem.title]);
    }
});
